import React, { useState, useEffect } from 'react';
import '../CSS/Navbar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <div className={`navbar ${isMobile ? 'hidden' : ''}`}>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/projects">Projects</Link></li>
          <li><Link to="/blog">Blog</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li><a href = "https://drive.google.com/file/d/10cZM-aQ5ALkOmuz6oPHVQG7ZRvmwhEgJ/view?usp=sharing">Resume</a></li>
        </ul>
      </div>

      {isMobile && (
        <button 
          className="hamburger-btn" 
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          ☰
        </button>
      )}

      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <button 
          className="close-btn" 
          onClick={toggleMenu}
          aria-label="Close menu"
        >
          ×
        </button>
        <ul>
          <li><Link to="/" onClick={toggleMenu}>Home</Link></li>
          <li><Link to="/about" onClick={toggleMenu}>About</Link></li>
          <li><Link to="/projects" onClick={toggleMenu}>Projects</Link></li>
          <li><Link to="/blog" onClick={toggleMenu}>Blog</Link></li>
          <li><Link to="/contact" onClick={toggleMenu}>Contact</Link></li>
          <li><a href = "https://drive.google.com/file/d/10cZM-aQ5ALkOmuz6oPHVQG7ZRvmwhEgJ/view?usp=sharing">Resume</a></li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;